/** True when a comment/page citation carries a 1-based page index. */
export function isPositivePageNum(
  page: number | null | undefined,
): page is number {
  return typeof page === "number" && page > 0;
}
